// @flow

// COMMON: Komponenta tlacitka Nacist dalsi v ramci strankovani
import UniversalPaginationButton from 'fg-frontend/components/UniversalPaginationButton';

// COMMON: Ostylovani select inputu pomoci knihovny Select2 (odeberte, pokud ostylovani nepouzivate)
import SelectDesign from './components/SelectDesign';

// COMMON: Napovedne popupy (odeberte, pokud v projektu nepouzivate, na eshopu napriklad na napovedy k parametrum a jako obecna knihovna pro zobrazovani napovednych textu)
import Tooltip from './components/Tooltip';

// COMMON: Komponenta, ktera upoznuje posilat do GTM Datalayeru zaznamu na zaklade zapisu v data atributech (odeberte, pokud GTM nepouzivate, jinak vyuzito primarne v eshopu)
import GtmHandler from './components/GtmHandler';

// COMMON: Komponenta, ktera vystreli specialni udalost v okamziku, kdy se objevi ve viewportu (pomocna komponenta pro GtmHandler, odeberte, pokud nepouzivate GTMHandler]
import TriggerInViewport from './components/TriggerInViewport';

// COMMON: Komponenta, ktera nastavi obrazek do rezimu lazy (odeberte, pokud nepouzivate lazy obrazky)
import LazyImage from './components/LazyImage';

// COMMON: Komponenta pro AJAX nacteni SVG spritu
import AddSvgIconSprite from './components/AddSvgIconSprite';

// COMMON: Všeobecná komponenta pro využití JS na globalní úrovni
import WebLayout from './components/WebLayout';

// COMMON: Komponenta pro zobrazení galerie
import PhotoSwipe from "./components/PhotoSwipe";

// COMMON: Hlavička
import Header from "./components/Header";

// COMMON: Default swiper
import DefaultSwiper from "./components/DefaultSwiper";

// COMMON: Page top swiper
import PageTopSwiper from "./components/PageTopSwiper";

// COMMON: Video modal
import VideoModal from "./components/VideoModal";

import NewsListing from './components/NewsListing';

// Komponenty pouzite primarne v eshopu (odkomentujte v pripade eshopu, ale pozor obsahuje i univerzalne pouzitelne komponenty, pokud potrebujete, nebojte se pouzit - tj. presunout sem)
// import configureEshopComponents from './configureEshopComponents';

export default (props) => {
	switch (props.decorator || props.is) {
		case 'WebLayout':
			return WebLayout;
		case 'GreedyMenu':
			return GreedyMenu;
		case 'UniversalPaginationButton':
			return UniversalPaginationButton;
		case 'Webslider':
			return Webslider;
		case 'Tooltip':
			return Tooltip;
		case 'GtmHandler':
			return GtmHandler;
		case 'LazyImage':
			return LazyImage;
		case 'SelectDesign':
			return SelectDesign;
		case 'AddSvgIconSprite':
			return AddSvgIconSprite;
		case 'PhotoSwipe':
			return PhotoSwipe;
		case 'Header':
			return Header;
		case 'DefaultSwiper':
			return DefaultSwiper;
		case 'PageTopSwiper':
			return PageTopSwiper;
		case 'VideoModal':
			return VideoModal;
		case 'NewsListing':
			return NewsListing;
		case 'Typeahead':
			// COMMON: Komponenta obecneho naseptavace (odeberte, pokud nepouzivate RJ komponentu typeahead nebo v eshopu vychozi naseptavace pobocek dopravnich spolecnosti)
			return import('fg-frontend/components/Typeahead');
		case 'PasswordToggle':
			// COMMON: Komponenta pro zapnuti/vypnuti viditelnosti vkladaneho hesla (odeberte, pokud nepouzivate registration modul)
			return import('fg-frontend/components/PasswordToggle');
		case 'SocialShare':
			// COMMON: Komponenta pro sdileni linku na socialni site (odeberte, pokud nepouzivate sdileni linku na socialni site, napr. v eshopu v detailu produktu)
			return import('fg-frontend/src/components/SocialShare');
		case 'CloseableAlert':
			// COMMON: Zaviratelny alert (odeberte pokud na komponente messages nepouzivate moznost zavreni)
			return import('fg-frontend/src/components/CloseableAlert');
		case 'GoogleRecaptcha':
			// COMMON: Google Recaptcha (odeberte pokud neupouzivate komponentu Google Recaptcha)
			return import('fg-frontend/src/components/GoogleRecaptcha');
		default:
			return null;
	}
};



// WEBPACK FOOTER //
// ./config/module-publish/resources-cvrez/js/configureWebComponents.js